import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
import { hexToRgba } from "@icarros/utils-react";
import { CardBaseVariants, } from "./constants";
const { color, opacity, size } = ids || {};
const getVariantStyle = (variant, hasHover = true) => {
    switch (variant) {
        case CardBaseVariants.primary:
            return css `
        background: ${hexToRgba(color.action.primary.ids_color_action_primary_base)};
        border: ${size.border_width.ids_size_border_small} solid
          ${color.action.primary.ids_color_action_primary_base};
        ${hasHover &&
                `&:hover {
            background: ${hexToRgba(color.action.primary.ids_color_action_primary_variant)};
          }`}
      `;
        case CardBaseVariants.secondary:
            return css `
        background: ${hexToRgba(color.action.secondary.ids_color_action_secondary_base)};
        border: ${size.border_width.ids_size_border_small} solid
          ${color.action.secondary.ids_color_action_secondary_variant};
        ${hasHover &&
                `&:hover {
            background: ${hexToRgba(color.action.secondary.ids_color_action_secondary_variant)};
          }`}
      `;
        default:
            return css `
        background: ${color.backgrounds.ids_color_bg_base};
        border: ${size.border_width.ids_size_border_small} solid
          ${color.border.ids_color_border_soft};
        ${hasHover &&
                `&:hover {
            background: ${hexToRgba(color.action.neutral.ids_color_action_neutral_base, opacity.ids_opacity_soft)};
          }`}
        ${({ selected }) => selected && isSelected}
      `;
    }
};
const isSelected = css `
  border: ${size.border_width.ids_size_border_small} solid
    ${color.action.primary.ids_color_action_primary_base};
`;
const StyledCard = styled.div `
  box-sizing: border-box;
  display: flex;
  width: fit-content;
  border-radius: ${size.corner_radius.ids_size_cornerRadius_card_01};
  ${({ variant, hasHover }) => getVariantStyle(variant, hasHover)}
`;
export default StyledCard;
//# sourceMappingURL=CardBase.styles.js.map